import { Box, Checkbox, CircularProgress, Grid, Typography } from '@mui/material'
import React from 'react';
import { SchemeMaster } from '../../../schemes/models/scheme_master';
import StepFormActions from '../create_user_shared/step_form_actions';
import { black, purple, purpleLight } from '../../../../theme/colors';

interface props {
    onSubmit: () => void;
    stepperCount: number;
    setStepperCount: (val: number) => void;
    masterDataList: SchemeMaster;
    masterDataLoading?: boolean;
    durableDetails: number[] | null;
    setDurableDetails: (val: number[] | ((prev: number[] | null) => number[])) => void;
    modifyUser?: boolean | undefined;
    disableSaveBtn?: boolean;
    setDisableSaveBtn?: (val: boolean) => void
}


export default function DurableDetailsComp({
    stepperCount,
    onSubmit,
    setStepperCount,
    masterDataList,
    masterDataLoading = false,
    durableDetails,
    setDurableDetails,
    modifyUser,
    disableSaveBtn = false,
    setDisableSaveBtn
}
    : props) {

    return (
        <Box>
            <Grid container mt={1} spacing={2}>
                {masterDataLoading ? (
                <Grid item xs={12}>
                    <Box display="flex" justifyContent="center" py={4}>
                        <CircularProgress size={28} sx={{ color: purple }} />
                    </Box>
                </Grid>
                ) : masterDataList.durableOwnership?.filter((data) => !data?.isAggregate).map((item) => {
                    const checked = !!durableDetails?.includes(item?.id);
                    return <Grid item md={6} lg={6} sm={12} xs={12} key={item.id}>
                        <Box
                            display={'flex'}
                            flexDirection={'row'}
                            justifyContent={'space-between'}
                            alignItems={'center'}
                            sx={{
                                border: `1px solid ${checked ? purple : '#ECECEC'}`,
                                borderRadius: 2,
                                bgcolor: checked ? purpleLight : 'transparent',
                                transition: 'border-color 0.15s ease, background-color 0.15s ease',
                            }}
                            px={2}
                            py={1}>
                            <Typography fontWeight={checked ? 600 : 400} color={black}>
                                {item?.value}
                            </Typography>
                            <Checkbox
                                checked={checked}
                                onClick={() => {
                                    // Functional update to avoid the same stale-closure
                                    // race as Areas of Interest — see that component.
                                    setDurableDetails((prev: number[] | null) => {
                                        const list = prev || [];
                                        return list.includes(item?.id)
                                            ? list.filter((i) => i !== item?.id)
                                            : [...list, item?.id];
                                    })
                                    setDisableSaveBtn?.(false)
                                }} />
                        </Box>
                    </Grid>
                })}
                <Grid item md={12} lg={12} sm={12} xs={12}>
                    <StepFormActions
                        showBack={!modifyUser}
                        onBack={() => setStepperCount(stepperCount - 1)}
                        disabled={disableSaveBtn || masterDataLoading}
                        onSubmitClick={onSubmit}
                        type="button"
                        submitLabel={!modifyUser ? "Proceed" : "Save Changes"}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}
